import { translate } from "../i18n/TranslationBackendRegistry";

export function withSentryEventIdDescription(
  description: string | undefined,
  sentryEventId: string | undefined,
): string | undefined {
  if (!sentryEventId) return description;

  const eventIdDescription = translate(
    "framework.error.eventIdLabel",
    "Fehler-ID: {{eventId}}",
    { eventId: sentryEventId },
  );
  return description
    ? `${description}\n${eventIdDescription}`
    : eventIdDescription;
}
